import { render } from "./TrashedMessage.vue?vue&type=template&id=25a2c498"
import script from "./TrashedMessage.vue?vue&type=script&lang=js"
export * from "./TrashedMessage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\ssd_ice\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__